module.exports = __webpack_public_path__ + "static/media/todolists.a4065e0a.png";